// extracted by mini-css-extract-plugin
export default {"extras":"LandingPage_extras__xctr5","img":"LandingPage_img__zAS2Z","video":"LandingPage_video__Tf7I0","fondoImagen":"LandingPage_fondoImagen__cfPoO"};